/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetEstimationRealtorFormModel,
  IGetEstimationRealtorFormRequest,
  IMappers,
  IGetEstimationRealtorFormResponse,
  IGetEstimationRealtorFormResponseError,
  TGetEstimationRealtorFormResponse,
} from './types';

const defaultConfig: TGetEstimationRealtorFormModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-realtor-form/',
  hostType: 'api',
} as TGetEstimationRealtorFormModel;

function createGetEstimationRealtorFormModel(
  parameters: IGetEstimationRealtorFormRequest,
): TGetEstimationRealtorFormModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationRealtorFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetEstimationRealtorFormRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetEstimationRealtorForm<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetEstimationRealtorFormOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetEstimationRealtorFormResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetEstimationRealtorFormModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationRealtorFormResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationRealtorFormResponseError);
    }
  }

  return { response, statusCode } as TGetEstimationRealtorFormResponse;
}

export { defaultConfig, createGetEstimationRealtorFormModel, fetchGetEstimationRealtorForm };
